import { HttpService } from '../../../services/common/http/common.http.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { formatTel } from '../../../utils/utility-functions';

@Component({
  selector: 'app-fornecedores-layout',
  templateUrl: './fornecedores-layout.component.html',
  styleUrls: ['./fornecedores-layout.component.scss'],
})
export class FornecedoresLayoutComponent implements OnInit {
  tableData: any[] = [];
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  constructor(private httpService: HttpService, private router: Router) {}

  ngOnInit() {
    this.getFornecedores();
  }

  pesquisaParams = {
    TxPesquisar: '',
    DtDiario: '',
    IsExport: false,
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  tableColumns = [
    { header: 'Nome', key: 'nome', type: 'text' },
    { header: 'Telefone', key: 'telefone', type: 'text' },
    { header: 'E-mail', key: 'email', type: 'text' },
    { header: 'Endereço', key: 'endereco', type: 'text' },
    { header: 'Valor do Frete', key: 'valorFrete', type: 'text' },
    { header: 'Dias Previstos', key: 'diasPrevistos', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Deletar',
          img: 'assets/images/del.svg',
          action: (item: any) => this.deleteDiarioDeObra(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    { header: 'Nome', key: 'nome', type: 'text', default: true },
    { header: 'Telefone', key: 'telefone', type: 'text', default: true },
    { header: 'E-mail', key: 'email', type: 'text' },
    { header: 'Endereço', key: 'endereco', type: 'text' },
    {
      header: 'Valor do Frete',
      key: 'valorFrete',
      type: 'text',
      default: true,
    },
    {
      header: 'Dias Previstos',
      key: 'diasPrevistos',
      type: 'text',
      default: true,
    },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/edit.svg',
          label: 'Editar',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          img: 'assets/images/del.svg',
          label: 'Deletar',
          action: (item: any) => this.deleteDiarioDeObra(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  getFornecedores() {
    this.loader = true;
    this.httpService
      .useGet('FornecedorByFilter', this.pesquisaParams)
      .subscribe({
        next: (res: any) => {
          if (!res.IsSuccess) this.tableData = [];
          this.tableData = res.DataSet.map((item: any) => {
            return {
              id: item.IdFornecedor,
              nome: item.NmFornecedor,
              email: item.TxEmailFornecedor ?? 'Não informado',
              telefone: formatTel(item.TxTelefoneFornecedor),
              endereco: item.TxEnderecoFornecedor,
              valorFrete: item.VlPrecoFreteFornecedor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }),
              diasPrevistos: `${item.QtDiaPrevisto} dias`,
            };
          });
        },
        error: (err: any) => {},
        complete: () => {
          this.loader = false;
        },
      });
  }

  editItem(item: any) {
    const params = {
      ...item,
      isEditing: true,
    };
    this.router.navigate(['fornecedores/cadastrar-fornecedor'], {
      queryParams: params,
    });
  }

  deleteDiarioDeObra(item: any): void {
    const id = item.id;
    const body = {
      NuStatusFornecedor: 3,
    };
    Swal.fire({
      title: 'Atenção!',
      text: 'Deseja realmente excluir o fornecedor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      confirmButtonText: 'Sim',
      cancelButtonColor: 'red',
      cancelButtonText: 'Não',
    }).then((result) => {
      this.loader = true;
      if (result.isConfirmed) {
        this.httpService.usePatch('FornecedorStatus', body, id).subscribe({
          next: (res: any) => {
            Swal.fire({
              title: 'Sucesso!',
              text: 'Fornecedor excluído com sucesso.',
              icon: 'success',
              confirmButtonText: 'Ok',
              confirmButtonColor: 'green',
            }).then(() => {
              this.getFornecedores();
            });
          },
          error: (err: any) => {
            Swal.fire({
              title: 'Erro!',
              text: 'Erro ao excluir o fornecedor.',
              icon: 'error',
              confirmButtonText: 'Ok',
              confirmButtonColor: 'red',
            });
          },
          complete: () => {
            this.loader = false;
          },
        });
      }
      this.loader = false;
    });
  }

  exportExcel() {
    this.pesquisaParams.IsExport = true;
    this.getFornecedores();
    this.pesquisaParams.IsExport = false;
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getFornecedores();
    }, 800);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getFornecedores();
  }

  navigateRegistrarDiario() {
    this.router.navigate(['fornecedores/cadastrar-fornecedor']);
  }
}
